import { Anchor, Button } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { Item } from 'typings'
import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerSubtitle,
  DrawerTitle,
  UseDrawerStateReturn,
} from '../../../Drawer'
import { Tag } from '../../../Tag'
import { messages } from './messages'
import { styles } from './styles'
import { OptInTable } from './Table'

type Props = {
  state: UseDrawerStateReturn
  sellers: Item[]
}

export function OptInList(props: Props) {
  const { state, sellers } = props

  const { $t } = useIntl()

  return (
    <Drawer state={state}>
      <DrawerHeader>
        <div className={styles.titleContainer}>
          <DrawerTitle>
            <FormattedMessage {...messages.drawer.title} />
          </DrawerTitle>
          <Tag className={styles.counter}>{sellers.length}</Tag>
        </div>
        <DrawerSubtitle>
          <FormattedMessage
            {...messages.drawer.subtitle}
            values={{
              a: (content: any) => null,
              //  Temporarily disable more information link until documentation is ready
              //  <Anchor target="_blank" href={$t(messages.moreInformation)}>
              //     {content}
              //   </Anchor>
            }}
          />
        </DrawerSubtitle>
      </DrawerHeader>
      <DrawerContent>
        <OptInTable sellers={sellers} />
      </DrawerContent>
      <DrawerFooter>
        <Button onClick={state.hide}>
          <FormattedMessage {...messages.drawer.close} />
        </Button>
      </DrawerFooter>
    </Drawer>
  )
}
